<template>
  <v-chip
    class="effective-date"
    :class="{ 'effective-date--button': asButton }"
    :tag="asButton ? 'button' : 'span'"
    :type="asButton ? 'button' : undefined"
    :aria-label="asButton ? 'Edit Effective from' : undefined"
    label
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    @click="openPostionEffective"
  >
    <span class="effective-res-label">
      {{ formattedEffectiveDate }}
    </span>
  </v-chip>
</template>

<script setup>
import { ref, defineEmits, computed } from "vue";
import Icon from "@components/icons/Icon.vue";
const props = defineProps({
  effectiveDate: {
    type: String,
    default: ""
  },
  asButton: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["position-date"]);
const isHovered = ref(false);
const formattedEffectiveDate = computed(() => {
  if (!props.effectiveDate) return "";
  // P9 (MDP-614): effective_date is a bare YYYY-MM-DD calendar date. Parse it as a
  // local date, never via `new Date(str)` (which reads it as UTC midnight and shifts
  // the day backwards in timezones behind UTC).
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(props.effectiveDate);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(props.effectiveDate);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
});
function openPostionEffective() {
  emit("position-date", props.effectiveDate);
}
</script>

<style scoped>
.effective-date {
  height: 28px !important;
  padding: 2px 6px 4px 6px;
  border-radius: 5px !important;
  background-color: transparent !important;
}
.effective-date:hover {
  border: 1px solid !important;
  border-color: #7F56D9 !important;
  background: #F2EDFF !important;
  box-shadow: 0px 8.25px 11.16px 0px #70707040, 0px -1.46px 3.88px 0px #FFFFFF40 inset, -4.85px -5.82px 8.74px 0px #2c0aed40 inset, 1.46px 1.94px 3.88px 0px #FFFFFFB2 inset !important;
}
.effective-date--button:focus-visible {
  outline: 2px solid #7F56D9;
  outline-offset: 1px;
}
.effective-res-label {
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #344054;
  margin-left: 2px;
  margin-top: 3px;
}
</style>
